import { post } from 'services/api';

export const uploadImage = (image: Blob) => async () => {
  const form = new FormData();
  form.append('file', image, 'upload-image.png');

  const { data } = await post({
    url: '/learner/upload',
    data: form,
  });

  return data.data.url;
};
